import { render, staticRenderFns } from "./unitedAirlinesWeek2.vue?vue&type=template&id=882d822a&scoped=true&"
import script from "./unitedAirlinesWeek2.vue?vue&type=script&lang=js&"
export * from "./unitedAirlinesWeek2.vue?vue&type=script&lang=js&"
import style0 from "./unitedAirlinesWeek2.vue?vue&type=style&index=0&id=882d822a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882d822a",
  null
  
)

export default component.exports